import React from "react"
import PropTypes from "prop-types"
import styled from "styled-components"
import { Link } from "gatsby"
import { breakpoints } from "../../../theme"

const TeaserHorizontal = ({ image, suptitle, title, excerpt, to }) => {
  return (
    <TeaserWrapper to={to} className="horizontal-teaser">
      <Image>{image}</Image>
      <Body>
        {suptitle && <Suptitle>{suptitle}</Suptitle>}
        {title && <Title>{title}</Title>}
        {excerpt && <Excerpt>{excerpt}</Excerpt>}
      </Body>
    </TeaserWrapper>
  )
}

const TeaserWrapper = styled(Link)`
  display: grid;
  grid-template-columns: 60px 1fr;
  grid-gap: 12px;
  text-decoration: none;
  width: 100%;
  color: var(--text-color);
  cursor: pointer;
  position: relative;
  font-size: 13px;

  @media (min-width: ${breakpoints.small}px) {
    grid-template-columns: 90px 1fr;
    grid-gap: 16px;
    font-size: 16px;
  }
`

const Image = styled.div`
  width: 60px;
  height: 60px;
  border-radius: 11px;
  background-color: var(--primary);
  overflow: hidden;

  @media (min-width: ${breakpoints.small}px) {
    width: 90px;
    height: 90px;
  }

  .gatsby-image-wrapper {
    width: 100%;
    height: 100%;
  }

  img {
    border-radius: 11px;
    overflow: hidden;
  }
`

const Body = styled.div`
  padding-top: 1px;
  padding-bottom: 5px;
  border-bottom: 1px solid var(--light);
  line-height: 1.2;
`

const Suptitle = styled.div`
  font-weight: 500;
  font-size: 1em;
  margin-bottom: 0.3em;
`

const Title = styled.div`
  margin: 0;
  font-size: 1.1em;
  font-weight: 700;
  letter-spacing: 0.2px;
  margin-bottom: 0.8em;
`

const Excerpt = styled.div`
  font-size: 1.05em;
`

TeaserHorizontal.propTypes = {
  image: PropTypes.element,
  suptitle: PropTypes.string,
  title: PropTypes.string.isRequired,
  excerpt: PropTypes.string,
  to: PropTypes.string.isRequired,
}

export { TeaserHorizontal }
